import computerGirl from '@/public/images/for-business/creative/1_computerGirl.webp';
import arm from '@/public/images/for-business/creative/2_arm.webp';
import rocket from '@/public/images/for-business/creative/3_rocket.webp';

export const forBusiness_creative_enhance = [
	{
		image: computerGirl,
		columnTitle: 'enhancesData_column1_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'enhancesData_column1_title1',
				subtitle: 'enhancesData_column1_subtitle1',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column1_title2',
				subtitle: 'enhancesData_column1_subtitle2',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column1_title3',
				subtitle: 'enhancesData_column1_subtitle3',
			},
		],
	},
	{
		image: arm,
		columnTitle: 'enhancesData_column2_columnTitle',
		items: [
			{
				icon: '🔹',
				title: 'enhancesData_column2_title1',
				subtitle: 'enhancesData_column2_subtitle1',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column2_title2',
				subtitle: 'enhancesData_column2_subtitle2',
			},
			{
				icon: '🔹',
				title: 'enhancesData_column2_title3',
				subtitle: 'enhancesData_column2_subtitle3',
			},
		],
	},
	{
		image: rocket,
		columnTitle: 'enhancesData_column3_columnTitle',
		items: [
			{
				icon: '🔹',
				subtitle: 'enhancesData_column3_subtitle1',
			},
			{
				icon: '🔹',
				subtitle: 'enhancesData_column3_subtitle2',
			},
			{
				icon: '🔹',
				subtitle: 'enhancesData_column3_subtitle3',
			},
		],
	},
];
